<template>
  <div>
    <v-container grid-list-lg fluid fill-height>
      <v-layout row wrap>
        <v-flex xs12>
          <OpenLeads />
        </v-flex>
        <v-flex xs12>
          <Leads />
        </v-flex>
        <v-flex xs12>
          <v-tabs fixed-tabs v-model="active" slider-color="info">
            <v-tab class="text-transform-none">{{ $t("labels.your") }}</v-tab>
            <v-tab
              class="text-transform-none"
              v-if="currentUser.accountTypeID !== 6 && currentUser.accountTypeID !== 5"
              >{{ $t("labels.all") }}</v-tab
            >
            <v-tabs-items touchless>
              <v-tab-item>
                <DueLeads />
              </v-tab-item>
              <v-tab-item>
                <AllUserLeads />
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Leads from "../../Home/components/Charts/Leads";
import DueLeads from "../../Home/components/Tables/DueLeads";
import AllUserLeads from "../../Home/components/Tables/AllUserLeads";
import OpenLeads from "../../Home/components/Tiles/OpenLeads";

import { mapGetters } from "vuex";

export default {
  data() {
    return {
      active: null,
    };
  },
  computed: {
    ...mapGetters("global", ["currentUser"])
  },
  components: {
    Leads,
    OpenLeads,
    DueLeads,
    AllUserLeads,
  },
};
</script>

<style scoped></style>
